export const ROUTE_ROUTES = '/routes';
export const ROUTE_MAP = '/map';
export const ROUTE_MAP_POI_TEMPLATE = '/map/:category/poi/:urlIdentifier';
export const ROUTE_MAP_FILTERS = '/map/filters';
export const ROUTE_MAP_TRAFFIC = '/map/traffic';
export const ROUTE_SEARCH_CAR = '/routes/search-car';
export const ROUTE_ZOI = '/routes/zoi';
export const ROUTE_ZOI_POI = '/routes/zoi/poi';
export const ROUTE_ZOI_FILTERS = '/routes/zoi/filters';
export const ROUTE_ZOI_SETTINGS = '/routes/zoi/settings';
export const ROUTE_GROUP_ZOI_SETTINGS = '/(map)/routes/zoi/settings';
export const ROUTE_COSTS = '/routes/costs';
export const ROUTE_GROUP_COSTS = '/(map)/routes/(details)/costs';
export const ROUTE_COSTS_EDIT = '/routes/costs/edit';
export const ROUTE_INSTRUCTIONS = '/routes/instructions';
export const ROUTE_ON_THE_WAY = '/routes/on-the-way';
export const ROUTE_ON_THE_WAY_POI = '/routes/on-the-way/poi';
export const ROUTE_ON_THE_WAY_FILTERS = '/routes/on-the-way/filters';
export const ROUTE_SEARCH = '/routes/search';
export const ROUTE_SEARCH_POI = '/routes/search/poi';
export const ROUTE_SEARCH_FILTERS = '/routes/search/filters';
export const ROUTE_RESULTS = '/routes/results';
export const ROUTE_GROUP_ZOI = '/(map)/routes/(details)/zoi';
export const ROUTE_GROUP_ZOI_POI = '/(map)/routes/(details)/zoi/poi';
export const ROUTE_GROUP_RESULTS_ADDRESSES = '/(map)/routes/results/[...addresses]';
export const ROUTE_GROUP_SEARCH_CAR = '/(map)/routes/search-car';
export const ROUTE_GROUP_DETAILS = '/(map)/routes/(details)';
export const ROUTE_GROUP_SEARCH = '/(map)/routes/(details)/search';
export const ROUTE_GROUP_SEARCH_POI = '/(map)/routes/(details)/search/poi';
export const ROUTE_GROUP_SEARCH_FILTERS = '/(map)/routes/(details)/search/filters';
export const ROUTE_GROUP_ON_THE_WAY = '/(map)/routes/(details)/on-the-way';
export const ROUTE_GROUP_ON_THE_WAY_POI = '/(map)/routes/(details)/on-the-way/poi';
export const ROUTE_GROUP_ON_THE_WAY_FILTERS = '/(map)/routes/(details)/on-the-way/filters';
export const ROUTE_GROUP_EXPENSE_NOTE = '/(map)/routes/(details)/expense-note';
export const ROUTE_GROUP_EXPENSE_NOTE_EDIT = '/(map)/routes/(details)/expense-note/edit';
export const ROUTE_GROUP_INSTRUCTIONS = '/(map)/routes/(details)/instructions';
export const PROFILE = '/profile';
export const PROFILE_FAVORITES = '/profile/favorites';
export const PROFILE_INFORMATION = '/profile/information';

export type RoutesIds =
        typeof ROUTE_ROUTES |
        typeof ROUTE_MAP |
        typeof ROUTE_MAP_POI_TEMPLATE |
        typeof ROUTE_MAP_FILTERS |
        typeof ROUTE_MAP_TRAFFIC |
        typeof ROUTE_SEARCH_CAR |
        typeof ROUTE_ZOI |
        typeof ROUTE_ZOI_POI |
        typeof ROUTE_ZOI_FILTERS |
        typeof ROUTE_ZOI_SETTINGS |
        typeof ROUTE_COSTS |
        typeof ROUTE_COSTS_EDIT |
        typeof ROUTE_INSTRUCTIONS |
        typeof ROUTE_ON_THE_WAY |
        typeof ROUTE_ON_THE_WAY_POI |
        typeof ROUTE_ON_THE_WAY_FILTERS |
        typeof ROUTE_SEARCH |
        typeof ROUTE_SEARCH_POI |
        typeof ROUTE_SEARCH_FILTERS |
        typeof ROUTE_RESULTS |
	typeof PROFILE_FAVORITES;
